function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.978 7.864c.03.088.03.184 0 .272C20.42 12.84 16.008 16 11 16 5.993 16 1.58 12.84.022 8.136a.434.434 0 0 1 0-.272C1.58 3.16 5.992 0 11 0c5.007 0 9.42 3.16 10.978 7.864zM11 14.222c3.538 0 6.417-2.791 6.417-6.222 0-3.43-2.879-6.222-6.417-6.222S4.583 4.569 4.583 8c0 3.431 2.879 6.222 6.417 6.222zM11 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
});

var SvgIconVisible = function SvgIconVisible(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon icon-visible",
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-visible.831fc0ce.svg";
export { ForwardRef as ReactComponent };